import { isAbortedOrCanceledHttpError } from '@/core/helpers/http-error.helper';
import { deepEqual } from '@nxtpeople/nxt-vue-library';
import { computed, watch } from 'vue';
import { LocationQuery, useRoute } from 'vue-router';

function normalizeError(error: unknown) {
   if (error instanceof Error) return error;

   if (typeof error === 'string') {
      return new Error(error);
   }

   return new Error('Unhandled promise rejection');
}

function useQueryWatcher(routeName: string, callback: (query?: LocationQuery) => void | Promise<void> = () => null, initialFetch = true) {
   const route = useRoute();
   const query = computed(() => route.query);

   if (callback) {
      watch(query, (newValue, oldValue) => watcher(callback, newValue, oldValue), { immediate: initialFetch });
   }

   function watcher(callback: (query?: LocationQuery) => void | Promise<void>, newValue: LocationQuery, oldValue?: LocationQuery) {
      // Check if query change occured on correct page
      if (route.name !== routeName) return;

      //check if query change was different from previous change
      if (deepEqual(newValue, oldValue)) return;

      //run callback
      const result = callback(newValue);

      if (result instanceof Promise) {
         return result.catch((error) => {
            if (isAbortedOrCanceledHttpError(error)) {
               return;
            }

            throw normalizeError(error);
         });
      }

      return result;
   }

   return { watcher, query };
}

export { useQueryWatcher };
